import React from 'react';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';
import ProBadge from '../../../../../../assets/images/icons/pro.svg';
import { overlayConfigs } from '../../../../../utils/mapbox/overlay_configs';
import MapSelection from '../../../../../components/MapSelection';
import { configMapSelectionSections } from '../../../../../utils/map_selection_helpers';
import { camelToDash } from '../../../../../utils/camel';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';

const createReactClass = require('create-react-class');

const hotkeysHash = {
  80: 'heatmap', // p
  79: 'nearbyTrails', // o
  76: 'recordingsAll', // l
  75: 'recordingsPop' // k
};

const IconMapOverlaySelection = createReactClass({
  getSections() {
    const languageRegionCode = this.props.context ? this.props.context.languageRegionCode : null;
    const overlaySections = [
      { key: 'free', cardKeys: ['waypoints', 'photos', 'nearbyTrails', 'distanceMarkers', 'waymarkedCycling', 'waymarkedHiking', 'waymarkedMTB'] },
      {
        key: 'pro',
        header: (
          <a
            className="pro-overlays-header"
            href={LanguageSupportUtil.wrapUrlSafe('/pro/signup', languageRegionCode)}
            target="_blank"
            rel="noreferrer"
          >
            <img alt={StringConstantsMixin.strings.PRO.ALLTRAILS_PRO} src={ProBadge} />
            <span>{StringConstantsMixin.strings.MAP_OVERLAYS}</span>
          </a>
        ),
        cardKeys: ['heatmap', 'weather', 'airQuality', 'lightPollution', 'pollen']
      }
    ];
    if (this.props.context && this.props.context.adminUser) {
      overlaySections.unshift({
        key: 'admin',
        cardKeys: [
          'contribs',
          'heatmap',
          'after',
          'limit',
          'mapsAll',
          'mapsAllHeatmap',
          'recordingsAll',
          'recordingsAllHeatmap',
          'recordingsPop',
          'recordingsPopHeatmap',
          'clusterTrails',
          'clusterTrailsHeatmap',
          'nearbyTrails',
          'nearbyTrailsHeatmap',
          'pendingTrails',
          'pendingTrailsHeatmap'
        ]
      });
    }
    return configMapSelectionSections(
      overlaySections,
      overlayConfigs,
      this.props.permissions,
      this.getCardImg,
      this.isCardSelected,
      this.props.terrainActive
    );
  },
  getCTAFooterConfig(closeModal) {
    return {
      primary: {
        label: StringConstantsMixin.strings.APPLY,
        onClick: closeModal
      },
      secondary: {
        label: StringConstantsMixin.strings.RESET,
        onClick: this.props.handleResetClick
      }
    };
  },
  getCardImg(overlay) {
    return `https://cdn-assets.alltrails.com/assets/map-layers/v2/map-overlay-${camelToDash(overlay)}@2x.png`;
  },
  isCardSelected(overlay) {
    return this.props.enabledOverlays.includes(overlay);
  },
  render() {
    return (
      <MapSelection
        adminLayout={this.props.context && this.props.context.adminUser}
        getCTAFooterConfig={this.getCTAFooterConfig}
        handleCardClick={this.props.handleCardClick}
        handleActivityFilterChange={this.props.handleActivityFilterChange}
        selectedFilterActivity={this.props.selectedFilterActivity}
        hotkeysHash={hotkeysHash}
        getSections={this.getSections}
        taller
        title={StringConstantsMixin.strings.MAP_OVERLAYS}
        type="overlay"
      />
    );
  }
});

export { IconMapOverlaySelection };
